<template>
  <!-- 经纪人列表 -->
  <div id="agentList">
    <!-- 头部数据更新时间模块 -->
    <headerUpdate></headerUpdate>
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <!-- 添加 -->
      <b-button class="add add-tab" variant="primary" @click="handleAdd" v-if="canAddAgent">
        <!-- <svg class="icon icon-12 icon-search" aria-hidden="true">
          <use xlink:href="#icon-v4_7_h"></use>
        </svg> -->
        {{ $t("common.add") }}
      </b-button>
      <b-row>
        <b-col lg="9">
          <!--搜索uid-->
          <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
            <b-form-input v-model.trim="searchUid" maxLength="10" placeholder=""></b-form-input>
          </b-form-group>
          <!-- 邮箱/手机下拉 -->
          <b-form-group class="find-middle">
            <!-- <label>
                <el-tooltip placement="top">
                  <div slot="content" :style="{ maxWidth: tipWidth }">
                    {{ $t("lanV4.ReturnedCommissionTip") }}
                  </div>
                  <span class="el_tooltip_bor">
                    {{ $t("lanV4.ReturnedCommission") }}</span
                  >
                </el-tooltip>
              </label> -->
            <v-select class="find-select" v-model="infoType" :options="infoTypeArr">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <!-- 邮箱/手机 搜索-->
          <b-form-group class="find-middle">
            <!-- <el-autocomplete
                class="el-input-vague"
                v-model="searchEmailPhone"
                :fetch-suggestions="querySearch"
                placeholder=""
                :trigger-on-focus="false"
                @select="handleSelectSearch"
                @input="changeDataSearch"
                maxlength="100"
              ></el-autocomplete> -->
            <b-form-input v-model.trim="searchEmailPhone" maxLength="100" placeholder=""></b-form-input>
          </b-form-group>

          <!--PID-->
          <b-form-group class="find-middle" :label="$t('lanV4.PID')">
            <b-form-input v-model.trim="pid" maxLength="10" placeholder=""></b-form-input>
          </b-form-group>

          <!--返佣级别-->
          <b-form-group class="find-middle" v-if="!disabledReturnLevel">
            <label>
              <el-tooltip placement="top">
                <div slot="content" :style="{ maxWidth: tipWidth }">
                  {{ $t("lanV4.ReturnedCommissionLevelTip") }}
                </div>
                <span class="el_tooltip_bor">
                  {{ $t("lanV4.ReturnedCommissionLevel") }}</span>
              </el-tooltip>
            </label>
            <v-select class="find-select" v-model="level" :options="levelArray">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <!-- 角色 -->
          <b-form-group :label="$t('lanV4.agentRoleName')" class="find-middle">
            <v-select class="find-select" v-model="roleName" :options="roleNameList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <!-- 注册时间 -->
          <b-form-group :label="$t('lanV4.addTime')" class="find-middle">
            <el-date-picker v-model="dateArray" unlink-panels type="datetimerange" value-format="timestamp"
              range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
              @change="handleChangeDate" :clearable="true" :picker-options="pickerOptions">
            </el-date-picker>
          </b-form-group>
        </b-col>
        <b-col lg="3" class="header-right-btn">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                      <use xlink:href="#icon-v4_17"></use>
                    </svg> -->
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                      <use xlink:href="#icon-v4_3"></use>
                    </svg> -->
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
                class="float-left"
                v-if="pages.total > 0"
                :total-rows="pages.total"
                :perPage="pages.size"
                :pageOptions="pages.options"
                :currentPage="pages.page"
                @initialize="pageChange"
                layout="total,sizes"
              >
              </v-page> -->
        <!-- 导出 -->
        <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          {{ exportButtonText }}
          <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass"
            :default-sort="{ prop: 'totalAmount', order: 'descending' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>

            <!--  序号 -->
            <el-table-column prop="sort" align="left" :label="$t('common.sort')">
            </el-table-column>

            <!--  uid-->
            <el-table-column prop="uid" align="right" :label="$t('lanV4.newUid')" width="150">
            </el-table-column>

            <!-- 备注-->
            <el-table-column prop="desc" align="right" :label="$t('transfer.remark')" width="150">
            </el-table-column>
            <!--  手机/邮箱-->
            <el-table-column prop="info" align="right" :label="$t('lanV4.agentEmaiPhone')" width="200">
              <template slot-scope="scope">
                <div>
                  <div>{{ scope.row.phone }}</div>
                  <div>{{ scope.row.email }}</div>
                </div>
              </template>
            </el-table-column>
            <!--  pid -->
            <el-table-column prop="pid" align="right" width="150">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    <!-- 直属上级UID -->
                    {{ $t("lanV4.pidTip2") }}
                  </div>
                  <span> {{ $t("lanV4.PID") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.pid }}
                </span>
              </template>
            </el-table-column>

            <!-- 返佣级别 -->
            <el-table-column v-if="!disabledReturnLevel" prop="returnLevel" :label="$t('lanV4.ReturnedCommissionLevel')"
              align="right" width="150">
            </el-table-column>

            <!-- 地区 -->
            <el-table-column prop="country" :label="$t('lanV4.Region')" align="right" width="160px">
            </el-table-column>

            <!--  角色 -->
            <el-table-column align="right" :label="$t('lanV4.agentRoleName')" width="150">
              <template slot-scope="scope">
                <el-popover placement="top" :title="scope.row.roleTypeDesc" width="300" manual-mode="scope.row.visible"
                  trigger="hover" popper-class="contract-params">
                  <div class="param-content">
                    <!-- <img
                      @click="handlePopoverClose"
                      class="close"
                      src="../../assets/images/v4_close.png"
                      alt=""
                    /> -->
                    <ul v-if="scope.row.roleType == 1">
                      <li>
                        <div class="left">
                          <!-- 返佣比例 -->
                          {{ $t("lanV4.RebateRate") }}
                        </div>
                        <div class="right">
                          {{ scope.row.scaleInfo[0].value }}
                        </div>
                      </li>
                    </ul>
                    <ul v-if="scope.row.roleType == 0 || scope.row.roleType == 2">
                      <li v-for="(item, index) in scope.row.scaleInfo" :key="index">
                        <div class="left">
                          <!-- 返佣比例 -->
                          {{ item.key }}
                        </div>
                        <div class="right">
                          {{ item.value }}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <span slot="reference" class="param-text">
                    {{ scope.row.roleName }}
                  </span>
                </el-popover>
              </template>
            </el-table-column>
            <!--  角色类型 -->
            <el-table-column align="right" prop="roleTypeDesc" :label="$t('roleManagement.rlType')" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.roleTypeDesc }}</span>
              </template>
            </el-table-column>
            <!--  返现比例-->
            <el-table-column align="right" prop="returnCashScale" :label="$t('lanV4.Rebateratiocash')" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.returnCashScale }}</span>
              </template>
            </el-table-column>
            <!--  添加时间-->
            <el-table-column prop="ctime" align="right" :label="$t('lanV4.addTime')" width="200">
            </el-table-column>
            <!-- 操作 -->
            <!--           fixed="right" -->
            <el-table-column v-if="hasRowOperationPermission" prop="action" :label="$t('common.find')" align="right" width="208px">
              <template slot-scope="scope">
                <!-- 编辑 -->
                <b-button v-if="canEditAgent" size="sm" variant="outline-primary" @click="handleEdit(scope.row)">
                  {{ $t("common.editor") }}
                </b-button>
                <!-- 冻结 -->
                <el-popover v-if="canFreezeAgent" @show="hideEmail()" placement="bottom" title="" width="300" manual-mode="scope.row.visible3">
                  <div class="content">
                    <!--冻结后该经纪人的返佣参与计算但不进行发放。你确定冻结该经纪人吗？ -->
                    {{ $t("lanV4.FreezeTip") }}
                  </div>
                  <!-- 邮件提醒 -->
                  <b-row class="email-tip">
                    <b-col>
                      <el-checkbox size="medium" v-model="emailSwitch">{{ $t('editInvitationCode.emailTip')
                        }}</el-checkbox>
                    </b-col>
                  </b-row>
                  <el-button class="el-popover-btn-del" size="mini" type="text" @click="handlePopoverClose()">
                    {{ $t("common.cancel") }}
                  </el-button>
                  <el-button class="el-popover-btn-confirm" type="primary" size="mini"
                    @click="handleFreeze(scope.row.uid)">
                    {{ $t("common.codeSuc") }}
                  </el-button>
                  <b-button v-if="scope.row.status == 1" style="margin-right: 10px" size="sm" variant="outline-primary"
                    slot="reference">
                    <!-- 冻结 -->
                    {{ $t("lanV4.Freeze") }}
                  </b-button>
                </el-popover>
                <!-- 解冻 -->
                <el-popover v-if="canFreezeAgent" @show="hideEmail()" placement="bottom" title="" width="300" manual-mode="scope.row.visible3">
                  <div class="content">
                    <!--解冻后冻结期间未发放的返佣将一并发送给该经纪人。你确定解冻该经纪人吗？ -->
                    {{ $t("lanV4.UnfreezeTip") }}
                  </div>
                  <!-- 邮件提醒 -->
                  <b-row class="email-tip">
                    <b-col>
                      <el-checkbox size="medium" v-model="emailSwitch">{{ $t('editInvitationCode.emailTip')
                        }}</el-checkbox>
                    </b-col>
                  </b-row>
                  <el-button class="el-popover-btn-del" size="mini" type="text" @click="handlePopoverClose()">
                    {{ $t("common.cancel") }}
                  </el-button>
                  <el-button class="el-popover-btn-confirm" type="primary" size="mini"
                    @click="handleUnfreeze(scope.row.uid)">
                    {{ $t("common.codeSuc") }}
                  </el-button>
                  <b-button v-if="scope.row.status == 0" size="sm" variant="outline-primary" slot="reference"
                    style="margin-right: 10px">
                    <!-- 解冻 -->
                    {{ $t("lanV4.Unfreeze") }}
                  </b-button>
                </el-popover>

                <!-- 删除 -->
                <el-popover v-if="canDeleteAgent" @show="hideEmail()" placement="bottom" title="" width="300" manual-mode="scope.row.visible3">
                  <div class="content">
                    <!--删除后该经纪人将不再享受返佣。你确定删除该经纪人吗？ -->
                    {{ $t("lanV4.DeleteTip") }}
                  </div>
                  <!-- 邮件提醒 -->
                  <b-row class="email-tip">
                    <b-col>
                      <el-checkbox size="medium" v-model="emailSwitch">{{ $t('editInvitationCode.emailTip')
                        }}</el-checkbox>
                    </b-col>
                  </b-row>
                  <el-button class="el-popover-btn-del" size="mini" type="text" @click="handlePopoverClose()">
                    {{ $t("common.cancel") }}
                  </el-button>
                  <el-button class="el-popover-btn-confirm" type="primary" size="mini"
                    @click="handleDelete(scope.row.uid)">
                    {{ $t("common.codeSuc") }}
                  </el-button>
                  <b-button size="sm" variant="outline-primary" slot="reference">
                    <!-- 删除 -->
                    {{ $t("lanV4.Delete") }}
                  </b-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{
            $t("exportsModal.text2", {
              pagesTotal: pages.total,
              maxNum: this.exportNumLimit,
            })
          }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
        }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>

    <agentListModal v-if="modalShow" :modalShow="modalShow" :modalType="modalType" :itemData="itemData"
      @changeModalShow="changeModalShow" @changeModalType="changeModalType">
    </agentListModal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
import agentListModal from "./components/agentListModal.vue";
import {
  AGENT_OPERATION_PERMISSION_FIELDS,
  DEFAULT_ROLE_OPERATION_PERMISSIONS,
  hasAgentOperationPermission,
  normalizeCurrentAgentOperationPermissions,
} from "./agentOperationPermissions";

export default {
  name: "agentList",
  mixins: [commonMixin],
  components: {
    headerUpdate,
    agentListModal,
  },
  data() {
    return {
      searchUid: null, // uid
      infoType: null, //查询类型
      searchEmailPhone: "", //模糊查询邮箱手机号
      restaurants: [], //模糊搜索返回值
      pid: null, //pid
      level: null, //返佣级别
      levelArray: [], //返佣级别下拉
      isKyc: null, //是否kyc
      roleName: null, //角色名称
      roleNameList: [], //角色名称列表
      dateArray: [new Date().getTime() - 86400000 * 30, new Date().getTime()],
      beginDate: null,
      endDate: null,

      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },

      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: true,
      tableList: [],
      modalShow: false,
      isexportIng: true,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "totalAmount", //默认排序字段
      sortSet: 1, //默认倒序
      modalType: null,
      itemData: null, //弹窗回显数据
      emailSwitch: false,//邮箱提醒开关
      operationPermissions: {
        ...DEFAULT_ROLE_OPERATION_PERMISSIONS,
      },
    };
  },
  computed: {
    // 邮箱,手机
    infoTypeArr() {
      return [
        {
          label: this.$t("lanV4.agentEmail"), //邮箱
          value: 0,
        },
        {
          label: this.$t("lanV4.agentPhone"), //手机
          value: 1,
        },
      ];
    },
    //是否kyc
    isKycArr() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.yes"), //是
          value: 1,
        },
        {
          label: this.$t("lanV4.no"), //否
          value: 0,
        },
      ];
    },
    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
    canAddAgent() {
      return this.roleType !== 3 && hasAgentOperationPermission(this.operationPermissions, AGENT_OPERATION_PERMISSION_FIELDS.add);
    },
    canEditAgent() {
      return this.roleType !== 3 && hasAgentOperationPermission(this.operationPermissions, AGENT_OPERATION_PERMISSION_FIELDS.edit);
    },
    canFreezeAgent() {
      return hasAgentOperationPermission(this.operationPermissions, AGENT_OPERATION_PERMISSION_FIELDS.freeze);
    },
    canDeleteAgent() {
      return hasAgentOperationPermission(this.operationPermissions, AGENT_OPERATION_PERMISSION_FIELDS.delete);
    },
    hasRowOperationPermission() {
      return this.canEditAgent || this.canFreezeAgent || this.canDeleteAgent;
    },
  },
  watch: {
    pid(v) {
      if (v) {
        this.$nextTick(() => {
          this.pid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    searchUid(v) {
      if (v) {
        this.$nextTick(() => {
          this.searchUid = fixInput(v, 0, { num: 1 });
        });
      }
    },
  },
  created() {
    this.getOperationPermissions();
    this.handleChangeDate();
    this.getReturnLevel();
    this.getRoleNameList();
    this.level = this.levelArray[0];
    this.infoType = this.infoTypeArr[0];
  },
  methods: {
    getOperationPermissions() {
      this.operationPermissions = {
        ...DEFAULT_ROLE_OPERATION_PERMISSIONS,
      };
      this.$http({
        url: this.$store.state.url.agent.index,
      })
        .then(({ data, code, msg }) => {
          if (data && code.toString() === "0") {
            this.operationPermissions = normalizeCurrentAgentOperationPermissions(data);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch(() => {});
    },
    showNoOperationPermission() {
      this.$bus.$emit("alert", {
        type: "error",
        message: this.$t("lanV4.noAgentOperationPermission"),
      });
    },
    hideEmail(){
       this.emailSwitch = false
    },
    // 模糊搜索
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    //@select 点击选中触发
    handleSelectSearch(item) {
      this.name = item.value;
      this.select = item.value;
      this.getnumber();
    },
    //@input 在 Input 值改变时触发
    changeDataSearch(value) {
      if (value != "") {
        this.getSelectSearchData();
      } else {
        this.image = "";
        this.select = "";
      }
    },
    // 获取模糊搜索接口
    getSelectSearchData() {
      this.$http({
        url: this.$store.state.url.agent.email,
        params: {
          type: this.infoType ? this.infoType.value : null,
          name: this.name,
        },
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.restaurants = data.restaurants.map((item) => {
            return {
              value: item.value,
            };
          });
        }
      });
    },
    // 删除弹窗关闭
    handlePopoverClose() {
      this.emailSwitch = false
      document.getElementById("agentList").click();
    },
    // 添加
    handleAdd() {
      if (!this.canAddAgent) {
        this.showNoOperationPermission();
        return;
      }
      this.itemData = null;
      this.modalType = "Add";
      this.modalShow = true;
    },
    //编辑
    handleEdit(row) {
      if (!this.canEditAgent) {
        this.showNoOperationPermission();
        return;
      }
      this.modalType = "Edit";
      this.itemData = row;
      this.modalShow = true;
    },
    //  0: 冻结
    // 1: 解冻
    // 2: 删除
    // 3: 添加
    // 4: 编辑
    // 冻结
    handleFreeze(uid) {
      if (!this.canFreezeAgent) {
        this.handlePopoverClose();
        this.showNoOperationPermission();
        return;
      }
      this.$http({
        url: this.$store.state.url.agent.co_agent_user_set,
        params: {
          uid: uid,
          status: 0,
          sendEmail: this.emailSwitch?1:0
        },
      }).then((data) => {
        this.handlePopoverClose();
        if (data && data.code.toString() === "0") {
          this.getData();
          this.$bus.$emit("alert", { type: "success", message: data.msg });
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    // 解冻
    handleUnfreeze(uid) {
      if (!this.canFreezeAgent) {
        this.handlePopoverClose();
        this.showNoOperationPermission();
        return;
      }
      this.$http({
        url: this.$store.state.url.agent.co_agent_user_set,
        params: {
          uid: uid,
          status: 1,
          sendEmail: this.emailSwitch?1:0
        },
      }).then((data) => {
        this.handlePopoverClose();
        if (data && data.code.toString() === "0") {
          this.getData();
          this.$bus.$emit("alert", { type: "success", message: data.msg });
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    // 删除
    handleDelete(uid) {
      if (!this.canDeleteAgent) {
        this.handlePopoverClose();
        this.showNoOperationPermission();
        return;
      }
      this.$http({
        url: this.$store.state.url.agent.co_agent_user_set,
        params: {
          uid: uid,
          status: 2,
          sendEmail: this.emailSwitch?1:0
        },
      }).then((data) => {
        this.handlePopoverClose();
        if (data && data.code.toString() === "0") {
          this.getData();
          this.$bus.$emit("alert", { type: "success", message: data.msg });
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },

    //   获取角色名称列表
    getRoleNameList() {
      this.$http({
        url: this.$store.state.url.agent.co_agent_role_menu_list,
        params: {
          uid: null,
          isAgentUserList: this.roleType == 3 || this.roleType == 4 ? 1 : null, //传1 角色列表应为所有下级经纪人角色的并集
        },
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          arr.push({ label: this.$t("common.all"), value: null });
          data.map((item) => {
            arr.push({ label: item.name, value: item.id });
          });
          this.roleNameList = arr;
          if (this.$route.query.roleName) {
            // 角色管理跳转过来
            this.dateArray = []; //时间止空
            arr.forEach((item) => {
              if (this.$route.query.roleName == item.value) {
                this.roleName = item;
              }
            });
          } else {
            this.roleName = arr[0];
          }
          this.getData();
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },

    // 选择时间
    handleChangeDate() {
      this.beginDate = this.dateArray[0];
      this.endDate = this.dateArray[1];
    },

    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "uid":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
        case "fee":
          this.sortName = "fee";
          break;
        case "returnAmount":
          this.sortName = "returnAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },

    // 获取返佣级别下拉
    getReturnLevel() {
      this.$http({
        url: this.$store.state.url.agent.level_list,
        params: {
          hasSelfReturn: 0, //不包含自返佣
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          arr.push({ label: this.$t("common.all"), value: null });
          if (data) {
            data.levelArray.map((item) => {
              arr.push({ label: item.levelName, value: item.level });
            });
            this.levelArray = arr;
            this.level = arr[0];
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },

    // 搜索
    query() {
      this.pages.page = 1;
      this.loading = true;
      this.getData();
    },
    // 重置
    reset() {
      this.searchUid = null;
      this.infoType = this.infoTypeArr[0];
      this.searchEmailPhone = null;
      this.pid = null;
      this.level = this.levelArray[0];
      this.isKyc = this.isKycArr[0];
      this.roleName = this.roleNameList[0];

      this.dateArray = [
        new Date().getTime() - 86400000 * 30,
        new Date().getTime(),
      ];
      this.handleChangeDate();
    },
    // 添加最新时间获取
    addGetTime() {
      this.dateArray = [
        new Date().getTime() - 86400000 * 30,
        new Date().getTime(),
      ];
      this.handleChangeDate();
      this.getData();
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        startTime: this.dateArray && this.dateArray[0] ? this.beginDate : null,
        endTime: this.dateArray && this.dateArray[1] ? this.endDate : null,
        uid: this.searchUid,
        pid: this.pid,
        phone: this.infoType.value ? this.searchEmailPhone : null,
        email: !this.infoType.value ? this.searchEmailPhone : null,
        returnLevel: this.level ? this.level.value : null,
        roleId: this.roleName ? this.roleName.value : null,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        isExport: 0,
      };
      this.$http({
        url: this.$store.state.url.agent.co_agent_user_list,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { total, rows } = datas.pageInfo;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (rows && rows.length) {
        rows.map((item, index) => {
          arr.push({
            id: item.id,
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            uid: item.uid,
            desc: item.desc ? item.desc : "--", //备注
            phone: item.phone, // 手机
            email: item.email, // 邮箱
            pid: item.pid && item.pid != 0 ? item.pid : "--",
            returnLevel: item.returnLevel, //返佣级别
            country: item.country ? item.country : "--", //地区
            roleName: item.roleName, //角色名称
            roleType: item.roleType, //角色类型（0:比例 1:极差)
            roleTypeDesc: item.roleTypeDesc, //角色类型str
            returnScale: item.returnScale, //极差经纪人返佣比例
            scaleInfo: item.scaleInfo, //比例经纪人返佣比例
            returnCashScale: item.returnCashScale, //返现比例
            ctime: item.ctime ? formatTime(item.ctime) : "--", //添加时间
            status: item.status, //冻结状态
            roleId: item.roleId, //角色id
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          startTime: this.dateArray ? this.beginDate : null,
          endTime: this.dateArray ? this.endDate : null,
          uid: this.searchUid,
          pid: this.pid,
          phone: this.infoType.value ? this.searchEmailPhone : null,
          email: !this.infoType.value ? this.searchEmailPhone : null,
          returnLevel: this.level ? this.level.value : null,
          roleName: this.roleName ? this.roleName.value : null,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          isExport: 1,
        };

        this.outExcel(
          this.$store.state.url.agent.co_agent_user_list,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
            this.exportsModalShow = false;
            setTimeout(() => {
              this.isexportIng = true;
            }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    changeModalShow(data) {
      this.modalShow = data;
    },
    changeModalType(data) {
      this.modalType = data;
    },
    onReset() {
      this.exportsModalShow = false;
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
};
</script>

<style lang="scss">
.el-popover {
  .email-tip {
    position: relative;
    text-align: left;
    margin-top: -10px;
    left: 6px;

    .el-checkbox__label {
      color: #253954;
    }

    .el-checkbox.is-checked {
      background: #fff !important;
    }

    .el-checkbox__inner {
      width: 14px !important;
      height: 14px !important;
      position: relative;
      top: -1px;
    }

    .el-checkbox__input.is-focus {
      .el-checkbox__inner {
        border-color: #DCDFE6 !important;
      }
    }

    .el-checkbox__input.is-checked {
      .el-checkbox__inner {
        border-color: #095BE8 !important;
      }
    }


  }
}

#agentList {


  .add-tab {
    position: absolute;
    top: 16px;
    right: 26px;
  }

  .custom-control {
    top: 5px !important;
  }
}
</style>
